import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, SECTION_STYLE_FIELDS } from './_fields'

const POST_ITEM: FieldSchema[] = [
  { key: 'title', label: 'Title', type: 'string' },
  { key: 'image', label: 'Cover (16:9)', type: 'image' },
  { key: 'excerpt', label: 'Excerpt', type: 'text' },
  { key: 'slug', label: 'Slug', type: 'string', help: 'Opens the post at /blog/<slug>.' },
  { key: 'date', label: 'Date', type: 'string', placeholder: '12 Sep 2026' },
  { key: 'category', label: 'Topic', type: 'string' },
]

const BLOG_FIELDS: FieldSchema[] = [
  { key: 'title', label: 'Title', type: 'string', default: 'From the blog' },
  { key: 'posts', label: 'Posts', type: 'array', itemSchema: POST_ITEM },
  { key: 'viewAllLink', label: 'View all link', type: 'string', default: '/blog' },
  { key: 'showViewAll', label: 'Show "View all"', type: 'boolean', default: true },
]

/** Blog cards (v1, v3) or a compact list (v2); on /blog/<slug> the matching post shows as an article. */
export const schema: ComponentSchema = {
  type: 'blog',
  label: 'Blog',
  description: 'Posts entered here, as cards with cover, topic, excerpt and date, or as a compact list.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Cards', fields: BLOG_FIELDS },
    { id: 'v2', label: 'Compact list', fields: BLOG_FIELDS },
  ],
  commonFields: [
    { key: 'source', label: 'Posts to show', type: 'select', options: [{ label: 'Live posts from the blog', value: 'posts' }, { label: 'Posts typed here', value: 'manual' }], help: 'Without a choice: typed posts when there are some, else the live blog.' },
    ...SECTION_STYLE_FIELDS,
  ],
}
